import isObject from 'lodash/isObject'

const itsOpenNowHasAvailability = (itsOpenNow: any): itsOpenNow is {itsAvailable: boolean} => {
  return !!itsOpenNow && isObject(itsOpenNow) && 'itsAvailable' in itsOpenNow
}

const isStoreOpenNow = store => {
  const itsOpenNow = store?.schedule?.itsOpenNow
  const storeIsOpenNow = itsOpenNowHasAvailability(itsOpenNow)
    ? itsOpenNow.itsAvailable
    : itsOpenNow

  return storeIsOpenNow
}

export default isStoreOpenNow
